import * as Sentry from "@sentry/react";

const isLocal = window.location.hostname === "localhost" || window.location.hostname === "mac-mini";

Sentry.init({
  dsn: "https://d44e56aa7cb3af5ed1483e81a194ceeb@o4510935691952128.ingest.us.sentry.io/4510935693262848",
  enabled: !isLocal,
  integrations: [Sentry.browserTracingIntegration()],
  // Session Replay is added lazily once the user consents (see lib/consent.ts).
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: 0.2,
  environment: isLocal ? "development" : "production",
  release: import.meta.env.VITE_APP_VERSION,
});
